$web-player-z-index: 100002;

:global(.withWebPlayer #usedesk-messenger .uw__messenger-layout__buttons) {
    bottom: 70px;
}

// !important is needed here for override inline styles of usedesk-widget
:global(.withWebPlayer #usedesk-messenger) {
    z-index: $web-player-z-index + 1 !important;
}
